import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Inputs from '../../Inputs/Inputs';
import SelectLocation from '../select-location/SelectLocation';
import style from './addListerInfo.module.css'
import axios from 'axios';
import appURL from '../../../appURL';


export default function AdsListerInfo({ onChangeHandler = () => { }, formData, isHideMobileNumberChecked = false, isHideEmailAddress1Checked = false, isHideEmailAddressChecked = false, hideEmailNumberSwitchButtonHandler = () => { }, postType = `` }) {
    const [countryCodes, setcountryCodes] = useState([]);
    const [errors, setErrors] = useState({ primary_phone_number: "", secondary_phone_number: "" });
    const baseURL = appURL();

const validatePhoneNumber = (name, value) => {
  let errorMsg = "";

  if (!value) {
    errorMsg = name === "primary_phone_number" ? "Primary phone number is required" : "";
  } else if (!/^\d+$/.test(value)) {
    errorMsg = "Only numbers are allowed";
  } else if (value.length !== 10) {
    errorMsg = "Phone number must be exactly 10 digits";
  }

  setErrors(prev => ({ ...prev, [name]: errorMsg }));
};

const handleChange = (e) => {
  const { name, value } = e.target;

  // Allow only numbers and max 10 digits
  if (value.length <= 10) {
    onChangeHandler(e);
  }

  validatePhoneNumber(name, value);
};

const handleBlur = (e) => {
  const { name, value } = e.target;
  validatePhoneNumber(name, value);
};

    useEffect(() => {
        const getCountryCodes = async () => {
            await axios.get(`${baseURL}/country_code_lists`)
                .then((res) => {
                    setcountryCodes(res?.data?.countryCode);
                })
                .catch((err) => {
                    console.log("err", err)
                })
        }
        getCountryCodes();
    }, [])

    return (
        <>
            {
                postType === `event` ?
                    <>
                        <Inputs
                            id='span-2'
                            required={true}
                            name='hosted_by'
                            value={formData?.hosted_by}
                            onChangeHandler={onChangeHandler}
                            label='Hosted by'
                            type='text'
                            disabled={localStorage.getItem('listerInfoChange') === 'true' ? false : true}
                            placeholder='Enter hosted by'

                        />
                    </> :
                    <Inputs
                        id='span-2'
                        name='name'
                        value={formData?.name}
                        onChangeHandler={onChangeHandler}
                        required={true}
                        disabled={localStorage.getItem('listerInfoChange') === 'true' ? false : true}
                        placeholder='Enter name'
                        label='Name'
                        type='text'
                    />
            }

            {formData.claim === true &&
                <div className="d-flex">
                    <input
                        type="checkbox"
                        id="claimCheckbox"
                        name="isClaimed"
                        checked={formData?.isClaimed || false}
                        onChange={(e) => {
                            onChangeHandler({
                                target: {
                                    name: 'isClaimed',
                                    type: 'checkbox',
                                    checked: e.target.checked
                                }
                            });
                        }}
                    />
                    <label htmlFor="claimCheckbox">Claim my business</label>
                </div>
            }

            <section id='span-2'>
                <Inputs
                    name='email_address'
                    required={true}
                    value={formData?.email_address}
                    onChangeHandler={onChangeHandler}
                    placeholder='Enter email address'
                    label='Email address'
                    disabled={true}
                    type='text'
                />
                <span className={style.email_hide_message_text}>Your email address will not be shared with others.</span>
            </section>


            <div id='span-2'>
                <label className="form-label">Primary phone number</label>
                <section id='primary_phone'>

                    <Inputs
                        lassName='my_code'
                        inputId={style.currency_input_field}
                        type='select'
                        name='country_code'
                        id='span-2'
                        value={formData?.country_code}
                        onChangeHandler={onChangeHandler}
                        selectInputOptions={countryCodes}
                    />

                    <Inputs
                        className='my_phone'
                        name='primary_phone_number'
                        value={formData?.primary_phone_number}
                        id='span-2'
                        // onChangeHandler={onChangeHandler}
                         onChangeHandler={handleChange}
                          onBlurHandler={handleBlur}
                        placeholder='Enter primary phone number'
                        // label='Primary phone number'
                        required={true}
                        type='number'
                        min={10}
                        max={10}
                    />
                </section>
                    {errors.primary_phone_number && (
                    <p style={{ color: "red", fontSize: "12px", margin: "4px 0 0 0" }}>
                    {errors.primary_phone_number}
                    </p>
                )}
            </div>


            <div id='span-2'>
                <label className="form-label">Secondary phone number(Optional)</label>
                <section id='primary_phone'>

                    <Inputs
                        inputId={style.currency_input_field}
                        type='select'
                        name='secondary_country_code'
                        id='span-2'
                        value={formData?.secondary_country_code}
                        onChangeHandler={onChangeHandler}
                        selectInputOptions={countryCodes}
                    />

                    <Inputs
                        className='my_phone'
                        name='secondary_phone_number'
                        id='span-2'
                        value={formData?.secondary_phone_number}
                        // onChangeHandler={onChangeHandler}
                       onChangeHandler={handleChange}   
                        onBlurHandler={handleBlur}        
                        placeholder='Enter Secondary phone number'
                        // label='Secondary phone number'
                        type='number'
                        min={10}
                        max={10}
                    />
                </section>

            {errors.secondary_phone_number && (
                <p style={{ color: "red", fontSize: "12px", margin: "4px 0 0 0" }}>
                {errors.secondary_phone_number}
                </p>
            )}
            </div>



            {/* <Inputs
                label='Hide my email address'
                type='switch'
                switchBtnChecked={isHideEmailAddressChecked}
                onChangeHandler={hideEmailNumberSwitchButtonHandler}
                name='hide_email_address'
                value={formData?.hide_email_address}
                className={style.switch_input_field}
            /> */}
            {/* 
            <Inputs
                label='Hide my email address'
                type='switch'
                id='span-2'
                min={10}
                max={15}
                inputClassName={style.switch_btn_wrapper}
                switchBtnChecked={isHideEmailAddress1Checked}
                onChangeHandler={hideEmailNumberSwitchButtonHandler}
                name='hide_my_email_address'
                required={true}
                value={isHideEmailAddress1Checked}
                className={style.switch_input_field1}
            /> */}

            <Inputs
                label='Hide my primary phone number'
                type='switch'
                id='span-2'
                min={10}
                max={15}
                inputClassName={style.switch_btn_wrapper}
                switchBtnChecked={isHideMobileNumberChecked}
                onChangeHandler={hideEmailNumberSwitchButtonHandler}
                // name='hide_primary_phone_number'
                   name='hide_phone_number'
                required={true}
                value={isHideMobileNumberChecked}
                className={style.switch_input_field1}
            />
            {
                formData.secondary_phone_number && (formData.secondary_phone_number.length > 9 && formData.secondary_phone_number.length <= 15) ?

                    <Inputs
                        label='Hide my secondary phone number'
                        type='switch'
                        required={true}
                        id='span-2'
                        inputClassName={style.switch_btn_wrapper}
                        switchBtnChecked={isHideEmailAddressChecked}
                        onChangeHandler={hideEmailNumberSwitchButtonHandler}
                        // name='hide_secondary_phone_number'
                           name='hide_email_address' 
                        value={isHideEmailAddressChecked}
                        className={style.switch_input_field1}
                    />
                    : ``
            }
        </>
    )
}
